class WaitList {
    constructor(options){
        if(options){
            this.client = options.client
            this.organizationID = options.organizationID
            this.currentOrganizationID = options.currentOrganizationID
            this.accountID = options.accountID
        }
    }
    fetch(options){
        return this.client.get(`/organizations/${options.organizationID}/wait-lists`, {params: options})
    }
    create(options){
        return this.client.post(`/organizations/${options.organizationID}/wait-lists`,options)
    }
    destroy(options){
        return this.client.delete(`/organizations/${options.organizationID}/wait-lists/${options.id}`);
    }
}

export default WaitList


// WEBPACK FOOTER //
// ./lib/apiClient/organizations/waitList.js